import { gql } from '@apollo/client'
import * as React from 'react'
import TypeaheadBox from '../../../../common/src/components/TypeaheadBox'
import { IntroText, EllipsisDiv, BodyTextSpan } from '../../../../common/src/components/core'
import { AddressAutocompleteQuery, AddressAutocompleteQueryVariables } from '../../../../common/src/types.gen'
import { apolloWebClient } from '../../apolloClientForWeb'

const addressAutocompleteQuery = gql`
  query AddressAutocomplete($prefix: String!) {
    addressAutocomplete(prefix: $prefix)
  }
`

const renderAddressRow = (address: string) => (
  <IntroText>
    <EllipsisDiv>
      <BodyTextSpan color="silver">{address}</BodyTextSpan>
    </EllipsisDiv>
  </IntroText>
)

export default class AddressChooser extends React.PureComponent<{
  hasError?: boolean
  onChoose: (val: string) => void
}> {
  private loadBound = async (prefix: string) => {
    if (!prefix) {
      return []
    }
    const result = await apolloWebClient.query<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>({
      query: addressAutocompleteQuery,
      variables: { prefix },
    })
    return result.data?.addressAutocomplete || []
  }

  render() {
    return (
      <TypeaheadBox<string>
        clearOnBlur={false}
        showResultsWhenEmpty={true}
        loadFunc={this.loadBound}
        rowFunc={renderAddressRow}
        hasError={this.props.hasError}
        onChoose={this.props.onChoose}
      />
    )
  }
}
